module.exports = __webpack_public_path__ + "static/assets/7a510583469b364d782108306c4de693.svg";